import React from "react";
import aboutstyles from "./aboutus.module.scss";
import { ERCText } from "components/text";
import { ERCButton } from "components/button";
import ExperienceCard from "components/experiencecard";
import Flying from "components/flying";
import { motion } from "framer-motion";
// import CourseCard from "components/studentcoursecard";
import { useNavigate } from "react-router-dom";
import CourseFilter from "components/coursefilter";
import student1 from "../../../assets/images/studentImg/student1.png";
import frame1171275787 from "../../../assets/images/heroImg/frame-1171275787.png";
import rectangle2751 from "../../../assets/images/heroImg/rectangle-2751.png";
import rectangle34624173 from "../../../assets/images/heroImg/rectangle-34624173.png";
import rectangle34624174 from "../../../assets/images/heroImg/rectangle-34624174.png";
import rectangle34624175 from "../../../assets/images/heroImg/rectangle-34624175.png";
import offerIcon7 from "../../../assets/images/offerImg/icon-7.svg";
import offerIcon8 from "../../../assets/images/offerImg/icon-8.svg";
import offerIcon9 from "../../../assets/images/offerImg/icon-9.svg";
import offerIcon10 from "../../../assets/images/offerImg/icon-10.svg";
import offerIcon11 from "../../../assets/images/offerImg/icon-11.svg";
import {
  TbWriting,
  TbDeviceGamepad2,
  TbBook2,
  TbHeartHandshake,
  TbDeviceDesktopAnalytics,
  TbShoppingCart,
} from "react-icons/tb";

const iconClass = "text-blue-500 w-10 h-10 md:w-8 md:h-8 mt-1";

const UnlockYourLearningFrame = () => {
  const navigate = useNavigate();
  return (
    <div className="flex gap-24 items-center w-full p-6">
      {/* <Flying l='3.5%' t='19%' > */}
      <Flying l="4%" t="265px">
        <motion.div
          animate={{ rotate: [45, 5] }}
          transition={{ repeat: Infinity, duration: 2, restSpeed: 0.5 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="43"
            viewBox="0 0 39 43"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.0489 40.1274C9.32492 39.0757 5.42609 38.5452 1.64397 38.0592C0.829355 37.9573 0.0730442 38.5259 0.0148577 39.3269C-0.101515 40.1286 0.480691 40.8617 1.23712 40.9636C4.90286 41.4314 8.68465 41.9321 12.234 42.9445C12.9904 43.1641 13.8054 42.7121 14.0381 41.9344C14.2709 41.1574 13.8053 40.3476 13.0489 40.1274Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.3375 25.2172C18.3443 19.0624 11.5947 13.6998 5.71783 7.37979C5.19415 6.78954 4.26317 6.75792 3.6813 7.30894C3.09944 7.86054 3.04148 8.78807 3.62334 9.37832C9.50018 15.7165 16.2498 21.0966 22.243 27.2696C22.8249 27.8458 23.7556 27.854 24.3375 27.2872C24.8612 26.721 24.9194 25.7934 24.3375 25.2172Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.5681 1.54341C35.7427 5.06616 35.9169 8.58891 36.0915 12.1123C36.0915 12.9192 36.7901 13.5422 37.6047 13.503C38.4193 13.4631 39.0008 12.7763 39.0008 11.9688C38.8262 8.44018 38.652 4.91216 38.4775 1.38413C38.4193 0.577224 37.7209 -0.0417174 36.9063 0.00219986C36.1499 0.0461172 35.5099 0.737085 35.5681 1.54341Z"
              fill="#00296B"
            />
          </svg>
        </motion.div>
      </Flying>
      <div className="md:w-1/2 w-full ">
        <div className="flex flex-col gap-6">
          <div>
            <div align="start">
              <ERCText lHeight="72px" weight="700" size="56px">
                Unlock Your{" "}
              </ERCText>
              <ERCText
                lHeight="72px"
                weight="700"
                size="56px"
                color={"#00296B"}
              >
                Learning Potential!
              </ERCText>
            </div>
          </div>

          {/* <ERCText
            width={"570px"}
            align="justify"
            lHeight="40px"
            weight="400"
            size="24px"
          >
            Experience the future of education with our platform. Start your
            academic journey to success now.
          </ERCText> */}
          <h2>
          Experience the future of education with our platform. Start your
          academic journey to success now.
          </h2>
        </div>
        <div className="py-6">
          <ERCButton
            weight={"700"}
            g={"8px"}
            size="16px"
            p={"16px 24px"}
            color="#FFD600"
            lHeight="24px"
            width="184px"
            showArrow
            onClick={() => {
              window.scrollTo(0, 0);
              navigate("/students-page");
            }}
          >
            Start Learning
          </ERCButton>
        </div>
      </div>
      <section className=" md:flex hidden w-full gap-6 md:w-1/2 ">
        {/* Left Side: Single Image */}
        <div className="w-1/2">
          <img
            className="md:h-[340px] lg:h-full lg:w-full w-full"
            src={student1}
            alt=""
          />
        </div>

        {/* Right Side: Stacked Images */}
        <div className="w-1/2 flex flex-col gap-6">
          <img
            className=" lg:w-full h-1/2"
            src={frame1171275787}
            alt=""
          />
          <img
            className=" lg:w-full h-1/2"
            src={rectangle2751}
            alt=""
          />
        </div>
      </section>
    </div>
  );
};

const UnlockYourLearning = () => {
  const navigate = useNavigate();
  return (
    <div className="flex gap-24 items-center w-full p-6">
      <Flying l="4%" t="270px">
        <motion.div
          animate={{ rotate: [45, 5] }}
          transition={{ repeat: Infinity, duration: 2, restSpeed: 0.5 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="43"
            viewBox="0 0 39 43"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.0489 40.1274C9.32492 39.0757 5.42609 38.5452 1.64397 38.0592C0.829355 37.9573 0.0730442 38.5259 0.0148577 39.3269C-0.101515 40.1286 0.480691 40.8617 1.23712 40.9636C4.90286 41.4314 8.68465 41.9321 12.234 42.9445C12.9904 43.1641 13.8054 42.7121 14.0381 41.9344C14.2709 41.1574 13.8053 40.3476 13.0489 40.1274Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.3375 25.2172C18.3443 19.0624 11.5947 13.6998 5.71783 7.37979C5.19415 6.78954 4.26317 6.75792 3.6813 7.30894C3.09944 7.86054 3.04148 8.78807 3.62334 9.37832C9.50018 15.7165 16.2498 21.0966 22.243 27.2696C22.8249 27.8458 23.7556 27.854 24.3375 27.2872C24.8612 26.721 24.9194 25.7934 24.3375 25.2172Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.5681 1.54341C35.7427 5.06616 35.9169 8.58891 36.0915 12.1123C36.0915 12.9192 36.7901 13.5422 37.6047 13.503C38.4193 13.4631 39.0008 12.7763 39.0008 11.9688C38.8262 8.44018 38.652 4.91216 38.4775 1.38413C38.4193 0.577224 37.7209 -0.0417174 36.9063 0.00219986C36.1499 0.0461172 35.5099 0.737085 35.5681 1.54341Z"
              fill="#00296B"
            />
          </svg>
        </motion.div>
      </Flying>
      <div className="md:w-1/2 w-full">
        <div className="flex flex-col gap-6">
          <div>
            <div align="start">
              <ERCText lHeight="72px" weight="700" size="56px">
                {" "}
                Invest in Your{" "}
              </ERCText>
              <ERCText
                lHeight="72px"
                weight="700"
                size="56px"
                color={"#00296B"}
              >
                {" "}
                Professional Growth!
              </ERCText>
            </div>
          </div>

          {/* <ERCText width={"570px"} lHeight="40px" weight="400" size="24px">
            Enhance your lessons with our curated collection of teaching
            resources. Professional Development Hub for Teachers. Supporting
            Teachers! Transforming Education!
          </ERCText> */}
          <h2>
          Enhance your lessons with our curated collection of teaching
            resources. Professional Development Hub for Teachers. Supporting
            Teachers! Transforming Education!
          </h2>
        </div>
        <div>
          <ERCButton
            weight={"700"}
            g={"8px"}
            size="16px"
            p={"16px 24px"}
            color="#FFD600"
            lHeight="24px"
            width="184px"
            showArrow
            onClick={() => {
              window.scrollTo(0, 0);
              navigate("/teachers-page");
            }}
          >
            Start Training
          </ERCButton>
        </div>
      </div>
      <section className="md:flex hidden w-full gap-6 md:w-1/2 ">
        {/* Left Side: Single Image */}
        <div className="w-1/2">
          <img
            className="md:h-[340px] lg:h-full lg:w-full w-full"
            src={rectangle34624174}
            alt=""
          />
        </div>

        {/* Right Side: Stacked Images */}
        <div className="w-1/2 flex flex-col gap-6">
          <img
            className=" lg:w-full h-1/2"
            src={rectangle34624173}
            alt=""
          />
          <img
            className=" lg:w-full h-1/2"
            src={rectangle34624175}
            alt=""
          />
        </div>
      </section>
    </div>
  );
};

const UnlockYourFrame = () => {
  const navigate = useNavigate();
  return (
    <div className="flex gap-24 items-center w-full p-6">
      <Flying l="4%" t="270px">
        <motion.div
          animate={{ rotate: [45, 5] }}
          transition={{ repeat: Infinity, duration: 2, restSpeed: 0.5 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="43"
            viewBox="0 0 39 43"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.0489 40.1274C9.32492 39.0757 5.42609 38.5452 1.64397 38.0592C0.829355 37.9573 0.0730442 38.5259 0.0148577 39.3269C-0.101515 40.1286 0.480691 40.8617 1.23712 40.9636C4.90286 41.4314 8.68465 41.9321 12.234 42.9445C12.9904 43.1641 13.8054 42.7121 14.0381 41.9344C14.2709 41.1574 13.8053 40.3476 13.0489 40.1274Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.3375 25.2172C18.3443 19.0624 11.5947 13.6998 5.71783 7.37979C5.19415 6.78954 4.26317 6.75792 3.6813 7.30894C3.09944 7.86054 3.04148 8.78807 3.62334 9.37832C9.50018 15.7165 16.2498 21.0966 22.243 27.2696C22.8249 27.8458 23.7556 27.854 24.3375 27.2872C24.8612 26.721 24.9194 25.7934 24.3375 25.2172Z"
              fill="#00296B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.5681 1.54341C35.7427 5.06616 35.9169 8.58891 36.0915 12.1123C36.0915 12.9192 36.7901 13.5422 37.6047 13.503C38.4193 13.4631 39.0008 12.7763 39.0008 11.9688C38.8262 8.44018 38.652 4.91216 38.4775 1.38413C38.4193 0.577224 37.7209 -0.0417174 36.9063 0.00219986C36.1499 0.0461172 35.5099 0.737085 35.5681 1.54341Z"
              fill="#00296B"
            />
          </svg>
        </motion.div>
      </Flying>
      <div className="md:w-1/2 w-full">
        <div className="flex flex-col gap-6">
          <div>
            <div align="start">
              <ERCText
                lHeight="72px"
                weight="700"
                size="56px"
                color={"#00296B"}
              >
                Empowering Emotional
              </ERCText>
              <ERCText lHeight="72px" weight="700" size="56px">
                {" "}
                Well-being!{" "}
              </ERCText>
            </div>
          </div>

          {/* <ERCText width={"570px"} lHeight="40px" weight="400" size="24px">
            Empowering Individuals to Thrive: Compassionate Counselling for
            Mental Well-being. Embrace the courage to seek guidance, for within
            vulnerability lies strength
          </ERCText> */}
          <h2>
          Empowering Individuals to Thrive: Compassionate Counselling for
            Mental Well-being. Embrace the courage to seek guidance, for within
            vulnerability lies strength
          </h2>
        </div>
        <div>
          <ERCButton
            weight={"700"}
            g={"8px"}
            size="16px"
            p={"16px 24px"}
            color="#FFD600"
            lHeight="24px"
            width="194px"
            showArrow
            onClick={() => {
              window.scrollTo(0, 0);
              navigate("/guidance-counselling");
            }}
          >
            Book A Session
          </ERCButton>
        </div>
      </div>
            <section className="md:flex hidden w-full gap-6 md:w-1/2 ">
        {/* Left Side: Single Image */}
        <div className="w-1/2">
          <img
            className="md:h-full lg:w-full w-full"
            src={rectangle34624175}
            alt="left-img"
          />
        </div>

        {/* Right Side: Stacked Images */}
        <div className="w-1/2 flex flex-col gap-6">
          <img
            className=" lg:w-full h-1/2"
            src={frame1171275787}
            alt="right-img"
          />
          <img
            className=" lg:w-full h-1/2"
            src={rectangle2751}
            alt=""
          />
        </div>
      </section>
    </div>
  );
};

const AboutUsFrame = () => {
  const GoodFrame = ({ msg }) => {
    return (
      <div className={aboutstyles.good}>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M23.334 14C23.334 16.4753 22.3507 18.8493 20.6003 20.5996C18.85 22.35 16.476 23.3333 14.0007 23.3333C11.5253 23.3333 9.15133 22.35 7.40099 20.5996C5.65065 18.8493 4.66732 16.4753 4.66732 14C4.66732 11.5246 5.65065 9.15065 7.40099 7.40031C9.15133 5.64997 11.5253 4.66664 14.0007 4.66664C14.8873 4.66664 15.7507 4.79497 16.5673 5.0283L18.399 3.19664C17.004 2.62213 15.5093 2.32874 14.0007 2.3333C12.4686 2.3333 10.9515 2.63507 9.53601 3.22138C8.12055 3.80768 6.83442 4.66704 5.75107 5.75039C3.56315 7.93832 2.33398 10.9058 2.33398 14C2.33398 17.0942 3.56315 20.0616 5.75107 22.2496C6.83442 23.3329 8.12055 24.1923 9.53601 24.7786C10.9515 25.3649 12.4686 25.6666 14.0007 25.6666C17.0948 25.6666 20.0623 24.4375 22.2502 22.2496C24.4382 20.0616 25.6673 17.0942 25.6673 14M9.22898 11.76L7.58398 13.4166L12.834 18.6666L24.5007 6.99997L22.8557 5.3433L12.834 15.365L9.22898 11.76Z"
              fill="#00296B"
            />
          </svg>
        </div>
        <ERCText
          align="justify"
          color="#525252"
          size="16px"
          weight="400"
          lHeight="24px"
        >
          {msg}
        </ERCText>
      </div>
    );
  };
  return (

      <div>
      {/* Original Design (visible only on large screens and above) */}
      <div className="hidden lg:block">
      <div className={aboutstyles.about}>
      <div className={aboutstyles.left}>
        <div className={aboutstyles.aboutdetails}>
          <div className={aboutstyles.header}>
            <div>
              <ERCText
                size="14px"
                weight="700"
                color={"#00296B"}
                lHeight="20px"
              >
                ABOUT US
              </ERCText>
              <hr
                width="50%"
                align="left"
                style={{ border: "1.5px solid #FFD600" }}
              />
            </div>
            <ERCText lHeight="48px" weight="700" size="40px">
              Education Resource Centre{" "}
            </ERCText>
          </div>

          <div className={aboutstyles.vorem}>
            <ERCText
              weight="400"
              size="16px"
              align="justify"
              color="#525252"
              lHeight="24px"
            >
              Established in 1967, the Lagos State Education Resource Centre
              features a library and ICT laboratory for internet access,
              educational material downloads, exam registration, result checks,
              and instructional material creation.
            </ERCText>
            <div className={aboutstyles.goodframe}>
              <GoodFrame
                msg={
                  "Production of instructional materials for Lagos' Public and Primary Schools."
                }
              />
              <GoodFrame
                msg={
                  "Sales of relevant instructional/learning materials for Public and Private schools in Lagos State"
                }
              />
              <GoodFrame
                msg={
                  "Availability of audio and audio-visual studios for artist recording at ERC"
                }
              />
              <GoodFrame
                msg={
                  "Courses on different subjects for Teachers' and Students' use."
                }
              />
            </div>
          </div>
          <div className={aboutstyles.learnmore}>
            <ERCButton
              weight={"700"}
              g={"8px"}
              size="16px"
              p={"16px 24px"}
              showArrow
              color="#FFD600"
            >
              Learn More
            </ERCButton>
          </div>
        </div>
        <div className={aboutstyles.dotted}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="107"
            height="109"
            viewBox="0 0 107 109"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M70.5034 104H70.4898C69.9123 104 69.4058 104.229 68.9841 104.558C68.9028 104.623 68.8012 104.66 68.7283 104.733C68.3235 105.14 68.0898 105.697 68.039 106.304C68.0339 106.372 68 106.431 68 106.501C68 106.81 68.0728 107.098 68.1762 107.37C68.21 107.458 68.2524 107.534 68.2947 107.617C68.3862 107.795 68.4963 107.96 68.6284 108.111C68.6927 108.186 68.7503 108.262 68.8232 108.328C69.023 108.51 69.2432 108.669 69.4939 108.779H69.4956C69.8056 108.917 70.1443 109 70.5034 109C71.6162 109 72.5257 108.26 72.8493 107.251C72.9356 107.02 72.9949 106.779 72.9966 106.514C72.9966 106.509 73 106.506 73 106.501C73 105.118 71.8821 104 70.5034 104ZM105.43 74.1883C105.188 74.0865 104.918 74.0475 104.642 74.0288C104.593 74.0271 104.554 74 104.503 74H104.49C103.111 74 102 75.1194 102 76.5017C102 76.8375 102.071 77.1547 102.191 77.443C102.276 77.6499 102.415 77.8161 102.545 77.9908C102.6 78.057 102.63 78.1384 102.688 78.1995C103.103 78.6404 103.675 78.9118 104.315 78.9627C104.319 78.9627 104.322 78.9644 104.326 78.9661V78.9644C104.387 78.9695 104.441 79 104.503 79C105.882 79 107 77.8806 107 76.5017C107 75.4501 106.348 74.558 105.43 74.1883ZM19.5034 30H19.4898C18.1111 30 17 31.1194 17 32.5C17 33.8789 18.1247 35 19.5034 35C20.8804 35 22 33.8789 22 32.5C22 31.1194 20.8804 30 19.5034 30ZM19.5034 89H19.4898C18.1111 89 17 90.1181 17 91.5008C17 92.8802 18.1247 94 19.5034 94C20.8804 94 22 92.8802 22 91.5008C22 90.1181 20.8804 89 19.5034 89ZM36.5034 50C37.8821 50 39 48.8789 39 47.5C39 46.1177 37.8821 45 36.5034 45H36.4915C35.1111 45 34 46.1177 34 47.5C34 48.8789 35.1247 50 36.5034 50ZM19.5034 15H19.4898C18.1111 15 17 16.1194 17 17.5C17 18.8806 18.1247 20 19.5034 20C20.8804 20 22 18.8806 22 17.5C22 16.1194 20.8804 15 19.5034 15ZM19.5034 59H19.4898C18.1111 59 17 60.1194 17 61.5C17 62.8806 18.1247 64 19.5034 64C20.8804 64 22 62.8806 22 61.5C22 60.1194 20.8804 59 19.5034 59ZM19.5034 74H19.4898C18.1111 74 17 75.1194 17 76.5017C17 77.8806 18.1247 79 19.5034 79C20.8804 79 22 77.8806 22 76.5017C22 75.1194 20.8804 74 19.5034 74ZM36.5034 20C37.8821 20 39 18.8806 39 17.5C39 16.1194 37.8821 15 36.5034 15H36.4915C35.1111 15 34 16.1194 34 17.5C34 18.8806 35.1247 20 36.5034 20ZM36.5034 35C37.8821 35 39 33.8789 39 32.5C39 31.1194 37.8821 30 36.5034 30H36.4915C35.1111 30 34 31.1194 34 32.5C34 33.8789 35.1247 35 36.5034 35ZM36.5034 5C37.8821 5 39 3.8806 39 2.5C39 1.1194 37.8821 0 36.5034 0H36.4915C35.1111 0 34 1.1194 34 2.5C34 3.8806 35.1247 5 36.5034 5ZM19.5034 45H19.4898C18.1111 45 17 46.1177 17 47.5C17 48.8789 18.1247 50 19.5034 50C20.8804 50 22 48.8789 22 47.5C22 46.1177 20.8804 45 19.5034 45ZM2.50508 59H2.48984C1.11111 59 0 60.1194 0 61.5C0 62.8806 1.12636 64 2.50508 64C3.88381 64 5 62.8806 5 61.5C5 60.1194 3.88381 59 2.50508 59ZM2.50508 45H2.48984C1.11111 45 0 46.1177 0 47.5C0 48.8789 1.12636 50 2.50508 50C3.88381 50 5 48.8789 5 47.5C5 46.1177 3.88381 45 2.50508 45ZM2.50424 74H2.48899C2.17553 74 1.88241 74.0712 1.60962 74.1798C1.47069 74.2324 1.35547 74.3172 1.23009 74.3935C1.12504 74.4596 1.0183 74.519 0.923416 74.6021C0.759065 74.7361 0.630295 74.8921 0.504914 75.0651C0.481193 75.1007 0.457472 75.133 0.433751 75.172C0.298204 75.3823 0.198238 75.6028 0.130464 75.8504L0.12877 75.8521V75.8538C0.0711623 76.0641 0 76.271 0 76.5017C0 77.4854 0.584548 78.3182 1.41308 78.7252V78.7269H1.41477C1.74517 78.8881 2.10098 78.9949 2.49068 78.9966C2.49576 78.9966 2.49915 79 2.50424 79C3.88343 79 5 77.8806 5 76.5017C5 76.1557 4.93053 75.8267 4.80346 75.5282C4.42562 74.6309 3.53778 74 2.50424 74ZM87.5034 45H87.4898C86.1111 45 85 46.1177 85 47.5C85 48.8789 86.1247 50 87.5034 50C88.8821 50 90 48.8789 90 47.5C90 46.1177 88.8821 45 87.5034 45ZM2.50424 30H2.48899C2.20434 30 1.94171 30.0628 1.69434 30.1611C1.46899 30.2391 1.27245 30.3562 1.08268 30.4919C1.08099 30.4919 1.08099 30.4919 1.0793 30.4936C0.440529 30.9464 0 31.6554 0 32.5C0 32.6069 0.0474415 32.6967 0.0609963 32.8019H0.0593019C0.0593019 32.8053 0.0609963 32.807 0.0626906 32.8087C0.14063 33.4176 0.413419 33.9552 0.848865 34.3453C0.908167 34.3996 0.982718 34.4301 1.04541 34.4776C1.21654 34.6031 1.38089 34.7337 1.58251 34.8134C1.86547 34.9305 2.17384 35 2.50424 35C3.53778 35 4.42562 34.3708 4.80346 33.4718C4.93053 33.1733 5 32.8443 5 32.5C5 32.1557 4.93053 31.8267 4.80346 31.5282C4.42562 30.6292 3.53778 30 2.50424 30ZM87.5034 59H87.4898C86.1111 59 85 60.1194 85 61.5C85 62.8806 86.1247 64 87.5034 64C88.8821 64 90 62.8806 90 61.5C90 60.1194 88.8821 59 87.5034 59ZM87.5034 30H87.4898C86.1111 30 85 31.1194 85 32.5C85 33.8789 86.1247 35 87.5034 35C88.8821 35 90 33.8789 90 32.5C90 31.1194 88.8821 30 87.5034 30ZM87.5034 89H87.4898C86.1111 89 85 90.1181 85 91.5008C85 92.8802 86.1247 94 87.5034 94C88.8821 94 90 92.8802 90 91.5008C90 90.1181 88.8821 89 87.5034 89ZM87.5034 74H87.4898C86.1111 74 85 75.1194 85 76.5017C85 77.8806 86.1247 79 87.5034 79C88.8821 79 90 77.8806 90 76.5017C90 75.1194 88.8821 74 87.5034 74ZM70.5042 5C71.8825 5 73 3.8806 73 2.5C73 2.5 72.9983 2.4983 72.9983 2.49661C72.9983 2.09125 72.8798 1.7232 72.7071 1.38399C72.6901 1.35176 72.6681 1.32802 72.6495 1.29749C72.4683 0.976934 72.2211 0.710651 71.9214 0.496947H71.9197C71.5117 0.20692 71.041 0 70.5042 0H70.4907C69.1124 0 68 1.1194 68 2.5C68 3.8806 69.126 5 70.5042 5ZM87.5034 15H87.4898C86.1111 15 85 16.1194 85 17.5C85 18.8806 86.1247 20 87.5034 20C88.8821 20 90 18.8806 90 17.5C90 16.1194 88.8821 15 87.5034 15ZM70.5034 30H70.4898C69.1111 30 68 31.1194 68 32.5C68 33.8789 69.1247 35 70.5034 35C71.8821 35 73 33.8789 73 32.5C73 31.1194 71.8821 30 70.5034 30ZM70.5034 74H70.4898C69.1111 74 68 75.1194 68 76.5017C68 77.8806 69.1247 79 70.5034 79C71.8821 79 73 77.8806 73 76.5017C73 75.1194 71.8821 74 70.5034 74ZM70.5034 59H70.4898C69.1111 59 68 60.1194 68 61.5C68 62.8806 69.1247 64 70.5034 64C71.8821 64 73 62.8806 73 61.5C73 60.1194 71.8821 59 70.5034 59ZM70.5034 45H70.4898C69.1111 45 68 46.1177 68 47.5C68 48.8789 69.1247 50 70.5034 50C71.8821 50 73 48.8789 73 47.5C73 46.1177 71.8821 45 70.5034 45ZM70.5034 89H70.4898C69.1111 89 68 90.1181 68 91.5008C68 92.8802 69.1247 94 70.5034 94C71.8821 94 73 92.8802 73 91.5008C73 90.1181 71.8821 89 70.5034 89ZM36.5034 64C37.8821 64 39 62.8806 39 61.5C39 60.1194 37.8821 59 36.5034 59H36.4915C35.1111 59 34 60.1194 34 61.5C34 62.8806 35.1247 64 36.5034 64ZM38.2683 104.733C38.1938 104.658 38.0921 104.621 38.0091 104.558C37.5874 104.229 37.081 104 36.5034 104H36.4898C35.1111 104 34 105.118 34 106.501C34 107.18 34.2761 107.79 34.7165 108.242C34.7182 108.243 34.7182 108.245 34.7199 108.245C35.1738 108.71 35.8039 109 36.5034 109C36.6355 109 36.749 108.946 36.876 108.925C36.8777 108.925 36.8794 108.924 36.8811 108.924C37.4705 108.832 37.9854 108.561 38.3598 108.131C38.4207 108.065 38.4563 107.984 38.5088 107.911C38.6223 107.75 38.7425 107.597 38.8171 107.412C38.9289 107.135 38.9949 106.833 38.9966 106.511C38.9966 106.508 39 106.506 39 106.501C39 105.866 38.7442 105.303 38.3564 104.862C38.3208 104.821 38.3056 104.769 38.2683 104.733ZM103.53 34.8033C103.83 34.9305 104.159 35 104.504 35C104.869 35 105.209 34.9135 105.521 34.7728C105.531 34.7677 105.538 34.7592 105.548 34.7542C105.853 34.6117 106.116 34.4117 106.338 34.1641C106.741 33.7216 107 33.1451 107 32.5008C107 31.1207 105.882 30 104.504 30H104.491C103.111 30 102 31.1207 102 32.5008C102 33.5351 102.632 34.4235 103.53 34.8033ZM104.504 50C105.882 50 107 48.8789 107 47.5C107 46.1177 105.882 45 104.504 45H104.491C103.111 45 102 46.1177 102 47.5C102 48.8789 103.123 50 104.504 50ZM104.504 64C105.882 64 107 62.8806 107 61.5C107 60.1194 105.882 59 104.504 59H104.491C103.111 59 102 60.1194 102 61.5C102 62.8806 103.123 64 104.504 64ZM53.5034 30H53.4915C52.1128 30 51 31.1194 51 32.5C51 33.8789 52.1247 35 53.5034 35C54.8821 35 56 33.8789 56 32.5C56 31.1194 54.8821 30 53.5034 30ZM53.5034 15H53.4915C52.1128 15 51 16.1194 51 17.5C51 18.8806 52.1247 20 53.5034 20C54.8821 20 56 18.8806 56 17.5C56 16.1194 54.8821 15 53.5034 15ZM53.5034 0H53.4915C52.1128 0 51 1.1194 51 2.5C51 3.8806 52.1247 5 53.5034 5C54.8821 5 56 3.8806 56 2.5C56 1.1194 54.8821 0 53.5034 0ZM36.5034 94C37.8821 94 39 92.8802 39 91.5008C39 90.1181 37.8821 89 36.5034 89H36.4915C35.1111 89 34 90.1181 34 91.5008C34 92.8802 35.1247 94 36.5034 94ZM36.5034 79C37.8821 79 39 77.8806 39 76.5017C39 75.1194 37.8821 74 36.5034 74H36.4915C35.1111 74 34 75.1194 34 76.5017C34 77.8806 35.1247 79 36.5034 79ZM53.5034 45H53.4915C52.1128 45 51 46.1177 51 47.5C51 48.8789 52.1247 50 53.5034 50C54.8821 50 56 48.8789 56 47.5C56 46.1177 54.8821 45 53.5034 45ZM70.5034 15H70.4898C69.1111 15 68 16.1194 68 17.5C68 18.8806 69.1247 20 70.5034 20C71.8821 20 73 18.8806 73 17.5C73 16.1194 71.8821 15 70.5034 15ZM53.5034 89H53.4915C52.1128 89 51 90.1181 51 91.5008C51 92.8802 52.1247 94 53.5034 94C54.8821 94 56 92.8802 56 91.5008C56 90.1181 54.8821 89 53.5034 89ZM53.5034 104H53.4915C52.1128 104 51 105.12 51 106.501C51 107.882 52.1247 109 53.5034 109C54.8821 109 56 107.882 56 106.501C56 105.12 54.8821 104 53.5034 104ZM53.5034 74H53.4915C52.1128 74 51 75.1194 51 76.5017C51 77.8806 52.1247 79 53.5034 79C54.8821 79 56 77.8806 56 76.5017C56 75.1194 54.8821 74 53.5034 74ZM53.5034 59H53.4915C52.1128 59 51 60.1194 51 61.5C51 62.8806 52.1247 64 53.5034 64C54.8821 64 56 62.8806 56 61.5C56 60.1194 54.8821 59 53.5034 59Z"
              fill="#FFD600"
            />
          </svg>
        </div>
      </div>
      <div className={aboutstyles.right}>
        <div className={aboutstyles.imgdiv}>
          <img
            className="w-[550px]"
            src={rectangle2751}
            alt=""
          />
        </div>
      </div>
    </div>
      </div>

      {/* Tailwind Design (visible only on smaller screens) */}
      <div className="block lg:hidden">
      <div className="w-full  px-4 py-8">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Section */}
        <div className="flex-1">
          <div>
            <h2 className="text-sm font-bold text-blue-900">ABOUT US</h2>
            <hr className="w-16 border-2 border-yellow-400 mt-2 mb-4" />
            <h1 className="text-3xl font-bold leading-snug">
              Education Resource Centre
            </h1>
          </div>
          <p className="mt-4 text-gray-600 text-base leading-6">
            Established in 1967, the Lagos State Education Resource Centre
            features a library and ICT laboratory for internet access,
            educational material downloads, exam registration, result checks,
            and instructional material creation.
          </p>

          {/* Good Frames */}
          <div className="mt-6 grid grid-cols-1 gap-4">
            <GoodFrame
              msg="Production of instructional materials for Lagos' Public and Primary Schools."
            />
            <GoodFrame
              msg="Sales of relevant instructional/learning materials for Public and Private schools in Lagos State."
            />
            <GoodFrame
              msg="Availability of audio and audio-visual studios for artist recording at ERC."
            />
            <GoodFrame
              msg="Courses on different subjects for Teachers' and Students' use."
            />
          </div>

          <button className="mt-6 px-6 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow hover:bg-yellow-500">
            Learn More
          </button>
        </div>

        {/* Decorative Element */}
        <div className="hidden lg:block">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="107"
            height="109"
            viewBox="0 0 107 109"
            fill="none"
          >
            {/* Dotted SVG Path */}
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="..."
              fill="#FFD600"
            />
          </svg>
        </div>
      </div>
    </div>

      </div>
    </div>
  );
};

const OurCoursesFrame = ({ btnFunction = () => null }) => {

  return (
    <div className="flex flex-col gap-12 px-8 md:px-20 lg:px-[120px] py-12 md:py-[140px] w-full">
    <div className="flex flex-col items-start text-center">
      <ERCText size="14px" weight="700" color="#00296B">
        OUR COURSES
      </ERCText>
      <hr className="border-2 border-[#F8D91A] w-[60px]" />
    </div>
    <div className="flex flex-col items-center text-center gap-4">
         <h2 className="md:text-[40px] text-[32px] font-bold leading-[48px]">
         Student Learning Centre
         </h2>
      <h2 className="text-[24px] font-normal leading-[32px] text-[#525252]">
        Embark on Your Learning Journey, Where Knowledge Thrives. Discover!
        Learn! Grow!
      </h2>
    </div>
    <div className="flex flex-col gap-10">
      <CourseFilter />
    </div>
    {/* Navigation Buttons */}
    {/* <div className="flex gap-5 justify-end items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
        <path d="M0 4C0 1.79086 1.79086 0 4 0H46C48.2091 0 50 1.79086 50 4V46C50 48.2091 48.2091 50 46 50H4C1.79086 50 0 48.2091 0 46V4Z" fill="#F6B40A" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
        <path d="M0 4C0 1.79086 1.79086 0 4 0H46C48.2091 0 50 1.79086 50 4V46C50 48.2091 48.2091 50 46 50H4C1.79086 50 0 48.2091 0 46V4Z" fill="#F6B40A" fill-opacity="0.4" />
      </svg>
    </div> */}
  </div>
  );
};

const WhatWeOffer = () => {
  const navigate = useNavigate();

  const goTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <div className="flex flex-col gap-12 bg-white py-12 md:px-[120px] px-6 w-full">
      <div className="flex flex-col items-start w-full justify-start gap-6">
        <ERCText size="14px" weight="700" color="#00296B">
          WHAT WE OFFER
        </ERCText>
        <hr className="w-[60px] border-[1.5px] border-[#05A6B2]" />
        <div>
          <ERCText lHeight="48px" color="#00296B" weight="700" size="40px">
            How To Enhance Your Experience
          </ERCText>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 w-full">
        <ExperienceCard
          onClick={() => goTo("/teachers-page")}
          img={<TbWriting className={iconClass} />}
          headerText="Training Resources"
          description="Access to a vast repository of educational materials, including interactive learning modules, worksheets, and reference materials for various subjects and grade levels."
        />

        <ExperienceCard
          onClick={() => goTo("/students-game-centre")}
          img={<TbDeviceGamepad2 className={iconClass} />}
          headerText="Games and Tasks"
          description="Engage in various educational games and tasks to stimulate learning and critical thinking skills. From classics like Scrabble, Chess, and Monopoly to other innovative educational games."
        />

        <ExperienceCard
          onClick={() => goTo("/students-page")}
          img={<TbBook2 className={iconClass} />}
          headerText="Study Guide"
          description="Explore comprehensive study guides tailored to students in all levels and special needs education. It provides valuable resources, tips, and strategies to support learning, revision, and exam preparation across different levels."
        />

        <ExperienceCard
          onClick={() => goTo("/guidance-counselling")}
          img={<TbHeartHandshake className={iconClass} />}
          headerText="Counselling Service"
          description="Confidential counseling services provided by trained professionals to address a range of issues such as bullying, mental health concerns, academic challenges, and personal development."
        />

        <ExperienceCard
          onClick={() => goTo("/students-page")}
          img={<TbDeviceDesktopAnalytics className={iconClass} />}
          headerText="Mock Exams"
          description="Prepare for examinations with Computer-Based Testing (CBT) mock exams specifically designed for senior secondary and junior secondary students."
        />

        <ExperienceCard
          onClick={() => goTo("/store")}
          img={<TbShoppingCart className={iconClass} />}
          headerText="Purchase Resources"
          description="Browse and purchase a variety of educational resources essential for schools in Lagos State. From attendance registers and lesson plans to primary, junior, and senior secondary school diaries, as well as continuous assessment."
        />
      </div>
    </div>
  );
};


const MarkFrame = ({ msg }) => {
  return (
    <div className={aboutstyles.mark}>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M23.333 13.9988C23.333 16.4741 22.3497 18.8481 20.5993 20.5984C18.849 22.3488 16.475 23.3321 13.9997 23.3321C11.5243 23.3321 9.15035 22.3488 7.40001 20.5984C5.64967 18.8481 4.66634 16.4741 4.66634 13.9988C4.66634 11.5234 5.64967 9.14943 7.40001 7.39909C9.15035 5.64875 11.5243 4.66542 13.9997 4.66542C14.8863 4.66542 15.7497 4.79375 16.5663 5.02708L18.398 3.19542C17.003 2.62091 15.5083 2.32752 13.9997 2.33208C12.4676 2.33208 10.9505 2.63385 9.53503 3.22016C8.11957 3.80646 6.83345 4.66582 5.7501 5.74917C3.56217 7.9371 2.33301 10.9046 2.33301 13.9988C2.33301 17.0929 3.56217 20.0604 5.7501 22.2483C6.83345 23.3317 8.11957 24.191 9.53503 24.7773C10.9505 25.3637 12.4676 25.6654 13.9997 25.6654C17.0939 25.6654 20.0613 24.4363 22.2493 22.2483C24.4372 20.0604 25.6663 17.0929 25.6663 13.9988M9.22801 11.7588L7.58301 13.4154L12.833 18.6654L24.4997 6.99875L22.8547 5.34208L12.833 15.3638L9.22801 11.7588Z"
            fill="#129748"
          />
        </svg>
      </div>
      <ERCText
        align="justify"
        color="#525252"
        size="16px"
        weight="400"
        lHeight="24px"
      >
        {msg}
      </ERCText>
    </div>
  );
};

const Cards = ({ img, header, description, paddingBottom, paddingTop }) => {
  const cardStyle = {
    ...(paddingBottom && { paddingBottom }), // Apply paddingBottom only if provided
    ...(paddingTop && { paddingTop }), // Apply paddingBottom only if provided
  };

  return (
    <div className={aboutstyles.cards} style={cardStyle}>
      <img className="w-[40px] h-[40px]" src={img} alt="identification" />
      <ERCText size="24px" weight="700" lHeight="32px">
        {header}
      </ERCText>
      <ERCText size="16px" weight="400" lHeight="24px">
        {description}
      </ERCText>
    </div>
  );
};

export default Cards;

export {
  UnlockYourLearningFrame,
  UnlockYourLearning,
  UnlockYourFrame,
  OurCoursesFrame,
  AboutUsFrame,
  WhatWeOffer,
  MarkFrame,
  Cards,
};
